import { extend, localize } from 'vee-validate';
import { required as rule_required, email as rule_email, max as rule_max, min as rule_min, confirmed as rule_confirmed, regex as rule_regex, between as rule_between, alpha as rule_alpha, integer as rule_integer, digits as rule_digits, alpha_dash as rule_alpha_dash, alpha_num as rule_alpha_num, length as rule_length, size as rule_size, } from 'vee-validate/dist/rules';
import cn from 'vee-validate/dist/locale/zh_CN.json';
import en from 'vee-validate/dist/locale/en.json';
// eslint-disable-next-line object-curly-newline
import { validatorPositive, validatorUrlValidator, validatorPassword, validatorStrongPassword, validatorCreditCard } from './validators';
// ////////////////////////////////////////////////////////
// General
// ////////////////////////////////////////////////////////
export const required = extend('required', rule_required);
export const email = extend('email', rule_email);
export const email_latin_only = extend('email_latin_only', value => {
    const EMAIL_RE = /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,9})$/;
    return EMAIL_RE.test(value);
});
export const uuid_like_only = extend('uuid_like_only', value => {
    const regex = /^[a-zA-Z0-9_-]+$/;
    return regex.test(value);
});
export const min = extend('min', rule_min);
export const max = extend('max', rule_max);
export const disableEmoji = extend('disableEmoji', {
    validate: function (value) {
        let isExistEmoji = false;
        /* eslint-disabled */
        const EMOJI_RE = /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/ig;
        if (value && typeof value === 'string') {
            isExistEmoji = EMOJI_RE.test(value);
        }
        return !isExistEmoji;
    },
});
export const confirmed = extend('confirmed', rule_confirmed);
export const regex = extend('regex', rule_regex);
export const between = extend('between', rule_between);
export const alpha = extend('alpha', rule_alpha);
export const integer = extend('integer', rule_integer);
export const digits = extend('digits', rule_digits);
export const alphaDash = extend('alpha-dash', rule_alpha_dash);
export const alphaNum = extend('alpha-num', rule_alpha_num);
export const length = extend('length', rule_length);
export const size = extend('size', rule_size);
export const positive = extend('positive', {
    validate: validatorPositive,
    message: 'Please enter positive number!',
});
export const credit = extend('credit-card', {
    validate: validatorCreditCard,
    message: 'It is not valid credit card!',
});
export const password = extend('password', {
    validate: validatorPassword,
});
export const strongPassword = extend('strongPassword', {
    validate: validatorStrongPassword,
});
export const url = extend('url', {
    validate: validatorUrlValidator,
});
export const unique = extend('unique', (value, otherValue) => {
    return otherValue.filter(item => item === value).length <= 1;
});
localize({
    en: {
        messages: {
            uuid_like_only: 'Can only contain letters, numbers, underscores, and hyphens',
            url: 'URL is invalid',
            disableEmoji: 'Special characters are not allowed in the text',
            password: 'The password can contain only letters, digits, and English symbols, must contain letters and digits, and length is 8 to 32.',
            strongPassword: 'Password must be 12 - 32 characters long and include uppercase and lowercase letters, digits, and English characters.',
            unique: 'Not unique.',
        },
    },
    cn: {
        messages: {
            uuid_like_only: '只可以包含英文字母、数字、下划线、减号',
            url: '无效URL',
            disableEmoji: '文本不允许包含特殊字符',
            password: '密码仅可由数字，字母，与英文符号组成，必须包含数字与字母，长度为8-32。',
            strongPassword: '密码长度为12-32位字符，必须包含大小写字母，数字，英文符号。',
            unique: '已经存在',
        },
    },
});
// Install English and Arabic localizations.
localize({
    en: {
        messages: {
            ...en.messages,
            fileSizeMb: 'The {_field_} field size must be less than {size}MB',
        },
        names: {
            email: 'Email',
            password: 'Password',
        },
        fields: {
            password: {
                min: '{_field_} is too short, you want to get hacked?',
            },
        },
    },
    cn: {
        messages: {
            ...cn.messages,
            fileSizeMb: '{_field_}必须小于{size}MB',
        },
        names: {
            email: 'Email',
            password: 'Password',
        },
        fields: {
            password: {
                min: '{_field_}太短，您想被黑客攻击吗？',
            },
        },
    },
});
// ////////////////////////////////////////////////////////
// NOTE:
// Quasar validation for reference only
// Remove this note once development is finished and make sure to
// to convert all of them in veevalidate version
// ////////////////////////////////////////////////////////
// export const required = (val) => {
//   return (val && val.length > 0) || '*Field is required'
// }
// export const required_obj = (obj) => {
//   if (obj === null || obj === undefined) return '*Field is required'
//   return (Object.entries(obj).length > 0 && obj.constructor === Object) || '*Field is required'
// }
// export const no_blank_spaces_arr = (arr) => {
//   return arr.every(val => (val.trim() && val.trim().length > 0)) || 'Blank Spaces are not allowed'
// }
// export const url = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true
//   // Used
//   // https://stackoverflow.com/questions/4314741/url-regex-validation
//   // Other
//   // https://stackoverflow.com/questions/5717093/check-if-a-javascript-string-is-a-url
//   // https://www.w3resource.com/javascript-exercises/javascript-regexp-exercise-9.php
//   // https://www.geeksforgeeks.org/how-to-validate-url-using-regular-expression-in-javascript/
//   /* eslint-disable no-useless-escape */
//   const re = /^(http[s]?:\/\/){0,1}(www\.){0,1}[a-zA-Z0-9\.\-]+\.[a-zA-Z]{2,5}[\.]{0,1}/
//   /* eslint-enable no-useless-escape */
//   return re.test(val) || 'URL is invalid'
// }
// export const date = val => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true
//   // https://github.com/quasarframework/quasar/blob/dev/ui/src/utils/patterns.js
//   return /^-?[\d]+\/[0-1]\d\/[0-3]\d$/.test(val) || 'Date is invalid'
// }
// export const max = (val, max) => {
//   // If blank return
//   if (val === undefined || val === null) return true
//   return val.length <= max || `More than ${max} characters are not allowed`
// }
// export const max_arr = (val, max) => {
//   return val.length <= max || `More than ${max} values are not allowed`
// }
// export const min = (val, min) => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true
//   return val.length >= min || `Minimum ${min} characters are required`
// }
// export const num_range = (val, min, max) => {
//   // If blank return
//   if (val === undefined || val === null || val.length === 0) return true
//   const msg = 'Value is invalid'
//   if (min === null) return val <= max || msg
//   else if (max === null) return val >= min || msg
//   else return (val >= min && val <= max) || msg
// }
